var waypoint = new Waypoint({
  element: $('.animate__animated.best-services-left'),
  handler: function(direction) {
    $('.animate__animated.best-services-left').addClass('animate__bounceInLeft');
  },
  offset: '100%'
})

var waypoint = new Waypoint({
  element: $('.animate__animated.best-services-right'),
  handler: function(direction) {
    $('.animate__animated.best-services-right').addClass('animate__bounceInRight');
  },
  offset: '100%'
})